export type UserRole =
  | 'system_admin'
  | 'admin'
  | 'owner'
  | 'supervisor'
  | 'technician'
  | 'customer';

export const USER_ROLE: Record<string, UserRole> = {
  SYSTEM_ADMIN: 'system_admin',
  ADMIN: 'admin',
  OWNER: 'owner',
  SUPERVISOR: 'supervisor',
  TECHNICIAN: 'technician',
  CUSTOMER: 'customer',
};

/** Platform console: create companies, global oversight */
export function isPlatformAdmin(role?: string | null): boolean {
  return role === 'system_admin' || role === 'admin';
}

/** Company office: own customers, techs, office chat */
export function isCompanyAdmin(role?: string | null): boolean {
  return role === 'owner' || role === 'supervisor';
}

export function isFieldTech(role?: string | null): boolean {
  return role === 'technician';
}

export function isCustomer(role?: string | null): boolean {
  return role === 'customer';
}
